import { render, staticRenderFns } from "./d-profile-bookshelf-list-entry.vue?vue&type=template&id=ab6018d2&scoped=true&"
import script from "./d-profile-bookshelf-list-entry.vue?vue&type=script&lang=js&"
export * from "./d-profile-bookshelf-list-entry.vue?vue&type=script&lang=js&"
import style0 from "./d-profile-bookshelf-list-entry.vue?vue&type=style&index=0&id=ab6018d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6018d2",
  null
  
)

export default component.exports